const SvgComponent = ({ title, description, ...props}) => (
  <svg
    width={414}
    height={294}
    viewBox='0 0 414 294'
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={16} y={274} width={331} height={4} rx={2} fill="#3F3F46" />
    <rect x={16} y={274} width={246} height={4} rx={2} fill="#7F39FA" />
    <text
      fill="#F1F2F2"
      xmlSpace="preserve"
      style={{
        whiteSpace: "pre",
      }}
      fontFamily="Inter"
      fontSize={12}
      fontWeight={500}
      letterSpacing="0em"
    >
      <tspan x={363.652} y={280.364}>
        {"- 0.02"}
      </tspan>
    </text>
  </svg>
)

export default SvgComponent
